.aboutUsContent {
    text-align: center;
    padding: 48px 20px;
    background-color: white;
}

.imageLinkSection {
    background: #e7f4f5;
    padding: 48px 20px;
}

.aboutUsHeading {
    color: #3caeb0;
    font-size: 32px;
    line-height: normal;
}

.inlineLink {
    color: #3caeb0;
    text-decoration: none;
}

.inlineLink:hover {
    text-decoration: underline;
}

.aboutUsForm {
    padding: 48px 0;
}

@media (min-width: 768px) {
    .aboutUsContent {
        padding: 96px 20px;
    }

    .imageLinkSection {
        padding: 96px 20px;
    }

    .aboutUsHeading {
        font-size: 50px;
        line-height: normal;
    }

    .aboutUsForm {
        padding: 96px 20px;
    }
}
